<ng-template #template
    let-data="data"
>
    <div *ngIf="hasCorrectionOffers(data)" class="mibi-correction-offer-hint">
        <mat-icon [inline]="true">arrow_drop_down</mat-icon>
    </div>
    <div class="mibi-data-cell"
        [mibiToolTip]="toolTipsOf(data)"
        [ngClass]="{
            'mibi-data-cell--auto-correction': hasAutoCorrection(data),
            'mibi-data-cell--warning': hasWarning(data),
            'mibi-data-cell--error': hasError(data),
            'mibi-data-cell--correction-offer': hasCorrectionOffers(data),
            'mibi-data-cell--edited': isEdited(data)
        }"
    ><span class="mibi-data-cell__value" [innerHTML]="data.value | softLineBreaks: ',\:;|-'"></span></div>
</ng-template>
